var decodeJwt = function (token) {
    var parts = token.split('.');
    if (parts.length !== 3) {
        throw new Error('Invalid JWT structure');
    }
    // Decode the payload (second part)
    var payload = parts[1];
    var decodedPayload = Buffer.from(payload, 'base64').toString('utf-8');
    return JSON.parse(decodedPayload);
};

export { decodeJwt };
